(function(){
  'use strict';
  var COOKIE_DISMISS = 'kj_idx_dismissed_v1';
  var COOKIE_JOINED  = 'kj_idx_joined_v1';
  var DAYS_DISMISS = 30;
  var DAYS_JOINED  = 365;
  var DELAY_MS = 15000;

  function getCookie(name){
    var m = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]+)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days){
    var d = new Date();
    d.setTime(d.getTime() + days*24*60*60*1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function forceShow(){
    try { return (location.search || '').indexOf('idx=show') !== -1; } catch(e){ return false; }
  }

  function shouldSuppress(){
    if (forceShow()) return false;
    if (getCookie(COOKIE_DISMISS) || getCookie(COOKIE_JOINED)) return true;
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/checkout') === 0) return true;
    if (path.indexOf('/cart') === 0) return true;
    return false;
  }

  var pop, opened = false, armed = false;

  function open(){
    if (opened || !pop) return;
    opened = true;
    pop.classList.add('is-open');
    pop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('idx-pop-open');
  }

  function close(remember){
    if (!pop) return;
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('idx-pop-open');
    if (remember) setCookie(COOKIE_DISMISS, '1', DAYS_DISMISS);
  }

  function arm(){
    if (armed) return;
    armed = true;
    if (forceShow()){ setTimeout(open, 50); return; }
    setTimeout(function(){ if (!opened) open(); }, DELAY_MS);
    document.addEventListener('mouseleave', function onLeave(e){
      if (e.clientY <= 0 && !opened){
        document.removeEventListener('mouseleave', onLeave);
        open();
      }
    });
  }

  function done(){
    var f = pop.querySelector('#idx-pop-form');
    var d = pop.querySelector('.idx-pop__done');
    if (f) f.style.display = 'none';
    if (d) d.hidden = false;
    setCookie(COOKIE_JOINED, '1', DAYS_JOINED);
    setTimeout(function(){ close(false); }, 3800);
  }

  function wire(){
    pop = document.getElementById('idx-pop');
    if (!pop) return;
    if (shouldSuppress()) return;

    Array.prototype.forEach.call(pop.querySelectorAll('[data-idx-close]'), function(el){
      el.addEventListener('click', function(){ close(true); });
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close(true);
    });

    var emailEl = pop.querySelector('input[name="contact[email]"]');
    var joinBtn = pop.querySelector('[data-idx-join]');
    var lbl = pop.querySelector('.idx-pop__cta-label');

    function submitEmail(){
      if (!emailEl) return;
      var email = (emailEl.value || '').trim();
      if (!email || email.indexOf('@') < 1) {
        emailEl.focus();
        return;
      }
      if (joinBtn && joinBtn.disabled) return;
      if (joinBtn) joinBtn.disabled = true;
      if (lbl) lbl.textContent = 'JOINING...';

      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[tags]', 'newsletter,the-index,popup');
      fd.append('contact[accepts_marketing]', 'true');
      fd.append('contact[email]', email);

      fetch('/contact', {
        method:'POST',
        body:fd,
        headers:{'X-Requested-With':'XMLHttpRequest', 'Accept':'application/json'},
        credentials:'same-origin',
        redirect:'follow'
      }).then(function(){ done(); }).catch(function(){ done(); });
    }

    if (joinBtn){
      joinBtn.addEventListener('click', function(e){
        e.preventDefault();
        submitEmail();
      });
    }
    if (emailEl){
      emailEl.addEventListener('keydown', function(e){
        if (e.key === 'Enter'){ e.preventDefault(); submitEmail(); }
      });
    }

    arm();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', wire);
  } else { wire(); }
})();
